import { useObserver } from "mobx-react";
import { MdInfoOutline } from "react-icons/md";
import Tooltip from "../reusble_components/tooltip";
import { useStores } from "../../store";
import { useEffect, useRef } from "react";

export default function Input(props) {
  const { RecuiterStore } = useStores();
  const mcqNumberOfQuestionsRef = useRef(null);

  // Format salary value based on currency
  const formatSalary = (value, currency) => {
    if (!value) return "";
    let num = Number(value);

    if (currency === "₹ India") {
      if (num >= 10000000) return `${(num / 10000000).toFixed(1)} Cr`; // Crore
      if (num >= 100000) return `${(num / 100000).toFixed(1)} L`; // Lakh
      if (num >= 1000) return `${(num / 1000).toFixed(0)} K`; // Thousand
    } else if (currency === "$ USA") {
      if (num >= 1000) return `${(num / 1000).toFixed(0)} K`; // Thousand
    } else if (currency === "€ Europe") {
      if (num >= 1000000) return `${(num / 1000000).toFixed(1)} M`; // Million
      if (num >= 1000) return `${(num / 1000).toFixed(0)} K`; // Thousand
    } else if (currency === "UGX Uganda") {
      if (num >= 1000000) return `${(num / 1000000).toFixed(1)} M`; // Million
      if (num >= 1000) return `${(num / 1000).toFixed(0)} K`; // Thousand
    }

    return num.toString(); // Less than 1000
  };

  useEffect(() => {
    if (props.label === "No. of Questions" && props.isMCQ) {
      mcqNumberOfQuestionsRef.current.value =
        Number(
          RecuiterStore.jobPostDetails.mcqTestDetails.sections[0].questions
        ) +
        Number(
          RecuiterStore.jobPostDetails.mcqTestDetails.sections[1].questions
        ) +
        Number(
          RecuiterStore.jobPostDetails.mcqTestDetails.sections[2].questions
        ) +
        Number(
          RecuiterStore.jobPostDetails.mcqTestDetails.sections[3].questions
        );
      if (mcqNumberOfQuestionsRef.current.value === "0") {
        mcqNumberOfQuestionsRef.current.value = "";
      }
    }
  }, [
    RecuiterStore.jobPostDetails.mcqTestDetails.sections[0].questions,
    RecuiterStore.jobPostDetails.mcqTestDetails.sections[1].questions,
    RecuiterStore.jobPostDetails.mcqTestDetails.sections[2].questions,
    RecuiterStore.jobPostDetails.mcqTestDetails.sections[3].questions,
  ]);

  useEffect(() => {
    if (
      props.label === "Job title" &&
      RecuiterStore.generateParams.title === ""
    ) {
      mcqNumberOfQuestionsRef.current.value = "";
    }
  }, [RecuiterStore.generateParams.title]);

  useEffect(() => {
    if (
      props.label === "Qualification" &&
      RecuiterStore.generateParams.qualification === ""
    ) {
      mcqNumberOfQuestionsRef.current.value = "";
    }
  }, [RecuiterStore.generateParams.qualification]);

  return useObserver(() => (
    <div
      className={`flex flex-col gap-2 text-lg ${props.width} md:w-full w-[100%] tc1:mb-2 sm:mb-0`}
    >
      {/* Label and Tooltip */}
      <span className="flex justify-between pr-3 items-center">
        <label className="font-sans text-base ml-3 text-[#6D6B6B]">
          {props.label}
        </label>
        {props.info && (
          <Tooltip id="info" content={props.infoText} position="top">
            <MdInfoOutline className="text-primary  text-base cursor-pointer" />
          </Tooltip>
        )}
      </span>

      {/* Input Field */}
      <input
        ref={mcqNumberOfQuestionsRef}
        type={props.type}
        required={props.required === true}
        placeholder={props.placeholder}
        onWheel={(e) => e.target.blur()} // Prevent number field scroll changes
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
        minVal={
          RecuiterStore.jobPostDetails.basicJobDetails.jobType === "intership"
            ? 0
            : 1
        }
        defaultValue={props.defaultValue || ""}
        onBlur={(e) => {
          if (
            props.questionMark &&
            e.target.value &&
            !e.target.value.endsWith("?")
          ) {
            e.target.value = e.target.value + " ?";
            props.action(e);
          }
        }}
        onChange={(e) => {
          let value = e.target.value;
          if (props.type === "number" && Number(value) > 9999999) {
            e.target.value = "10000000";
            // return;
          }
          if (props.regex && props.regexFormula instanceof RegExp) {
            if (!props.regexFormula.test(e.target.value)) {
              e.target.value = e.target.value.slice(0, -1); // Remove last character if invalid
            } else {
              props.action(e); // Call action if valid
            }
          } else {
            props.action(e); // Call action for all inputs
          }
        }}
        className={`border px-4 rounded-lg text-base border-[#c9c9c9] ${props.inputStyling} ${
          props.height || "h-10" // Default height if not provided
        }`}
        {...(props.mcq && { value: props.defaultValue || "" })}
        {...(props.type === "number" && props.unres !== "true"
          ? props.label === "Number of MCQ's"
            ? { min: "20" }
            : { min: "1" }
          : {})}
        {...(props.type === "number" && props.max ? { max: props.max } : {})}
        {...(props.label === "Qualification" && {
          value: props.defaultValue || "",
        })}
      />

      {/* Salary Formatting */}

      {props.label === "Salary" && !(props.placeholder === "Salary paid") && (
        <div
          onClick={() => console.log(props.currency)}
          className={` ml-2 h-[0.5rem] ${
            props.defaultValue ? "text-gray-500" : "text-transparent"
          }`}
        >
          {props.defaultValue
            ? formatSalary(props.defaultValue, props.currency)
            : "hello"}
        </div>
      )}
    </div>
  ));
}
